<template>
    <div class="page-filter">

        <div class="page-filter-header" @click="showPageFilterContent()" v-if="showFilterLabel">
            <i v-if="icon" class="color-brand--secondary fa-fw" :class="[
                icon,
                (viewTypeValue === 'desktop') ? 'font-size-medium' : '',
                (viewTypeValue === 'mobile') ? 'font-size-large' : '',
            ]"></i>
            <h4 class="m-0 d-inline-block color-brand--secondary" >
                {{ this.selectedItemsString }}
            </h4>
            <small class="d-block" v-if="selectedItemsSubString">{{selectedItemsSubString}}</small>
        </div>

        <div class="page-filter-content d-md-block"
             v-bind:class="{ 'd-none' : !isPageFilterContentVisible && !parentFilterId }"
        >
            <slot name="before-options "></slot>

            <div class="z-index-10 mobile-filter-nav" v-if="!parentFilterId">
                <div class="row">
                    <div class="col-4">
                        <span class="d-block" @click="hidePageFilterContent"><i class="fas fa-chevron-left pr-1"></i> Terug</span>
                    </div>
                    <div class="col-4 text-center">
                        {{plural}}
                    </div>
                    <div class="col-4 text-right">
                        <span @click="removeFilters(id)" v-if="Object.keys(selected).length !== 0">Wis filters</span>
                    </div>
                </div>
            </div>

            <div v-bind:class="{'mobile-filter-nav-spacer': !parentFilterId}">
                <div v-if="allowSearch && selectableItems.length > 10" class="my-3 position-relative d-flex">
                <span class="position-absolute px-3 h-100 d-flex align-items-center">
                    <i class="fas fa-search font-size-small"></i>
                </span>

                    <input type="search"
                           v-model="search"
                           :name="inputName"
                           class="pl-5 w-100 size-small text-center color-brand--secondary box-shadow-small page-filter-city-input"
                           :placeholder="'Zoek ' + plural"
                           :disabled="isLocked"
                    >
                    <span class="position-absolute px-3 h-100 d-flex align-items-center right-0 cursor-pointer">
                    <i class="fas fa-times" v-show="search.length" @click="emptySearchInput"></i>
                </span>
                </div>

                <div class="filter-items-container">
                    <div v-for="(item, index) in filteredItems.slice(0, (moreBreakpoint > -1 ? moreBreakpoint : 999))"
                         class="mb-3 page-filter-selectable-item"
                    >

                        <input type="checkbox"
                               v-model="selected[item.id]"
                               :class="viewTypeValue"
                               class="d-none page-filter-checkbox"
                               :name="inputName + '[]'"
                               :id="idPrefix + '-' + item.id + '-item-' + index"
                               :value="item.value"
                               :input-label="item.label"
                               :disabled="isLocked"
                               @change="setSelected(item.id, item.children)"
                        >

                        <label :for="idPrefix + '-' + item.id + '-item-' + index"
                               class="page-filter-label"
                               :class="{ 'btn btn-secondary w-100': (viewTypeValue === 'mobile') }"
                        >
                            <div v-if="viewTypeValue === 'desktop'"
                                 class="d-inline-block custom-checkbox"
                            ></div>
                            {{ item.label }}


                            <small v-if="id === 'cinema' && cinemaDistances && cinemaDistances[item.id]">
                                - {{cinemaDistances[item.id] | kilometers}}
                            </small>
                        </label>

                        <div v-if="selected[item.id] && item.children.values.length" class="page-filter-children small">
                            <page-filter
                                    is="page-filter"
                                    :key="item.id"
                                    :page-filter-type="item.children.id"
                                    :id="item.children.id"
                                    :id-prefix="idPrefix + '-' + item.id + '-' + item.children.id"
                                    :plural="item.children.label"
                                    :input-name="item.children.label"
                                    :items="item.children.values"
                                    :moreBreakpoint="-1"
                                    :showFilterLabel="false"
                                    :defaultSelected="true"
                                    :parentId="item.id"
                                    :parentFilterId="id"
                                    :allowSearch="false"
                            ></page-filter>
                        </div>
                    </div>

                    <div class="collapse" :id="'more-filters-' + idPrefix + inputName" v-if="search.length < 3">
                        <div v-for="(item, index) in selectableItems.slice(moreBreakpoint)" class="page-filter-selectable-item">
                            <input type="checkbox"
                                   v-model="selected[item.id]"
                                   :class="viewTypeValue"
                                   class="d-none page-filter-checkbox"
                                   :name="inputName + '[]'"
                                   :id="idPrefix + inputName + '-item-' + (index + moreBreakpoint)"
                                   :value="item.value"
                                   :input-label="item.label"
                                   :disabled="isLocked"
                                   @change="setSelected(item.id, item.children)"
                            >

                            <label :for="idPrefix + inputName + '-item-' + (index + moreBreakpoint)"
                                   class="mb-3 page-filter-label"
                                   :class="{ 'btn btn-secondary w-100': (viewTypeValue === 'mobile') }"
                            >
                                <div v-if="viewTypeValue === 'desktop'"
                                     class="d-inline-block custom-checkbox"
                                ></div>
                                {{ item.label }}
                            </label>

                            <div v-if="selected[item.id] && item.children.values.length" class="page-filter-children small">
                                <page-filter
                                        is="page-filter"
                                        :key="item.id"
                                        :page-filter-type="item.children.id"
                                        :id="item.children.id"
                                        :id-prefix="idPrefix + '-' + item.id + '-' + item.children.id"
                                        :plural="item.children.label"
                                        :input-name="item.children.label"
                                        :items="item.children.values"
                                        :moreBreakpoint="-1"
                                        :showFilterLabel="false"
                                        :defaultSelected="true"
                                        :parentId="item.id"
                                        :parentFilterId="id"
                                        :allowSearch="false"
                                ></page-filter>
                            </div>
                        </div>
                    </div>

                    <div v-if="moreBreakpoint > -1 && selectableItems.length > moreBreakpoint && search.length < 3">
                        <a class="mb-3 d-block collapsed color-font text-center variable-collapse-button"
                           :href="'#more-filters-' + idPrefix + inputName"
                           role="button"
                           data-toggle="collapse"
                           aria-expanded="false"
                           :aria-controls="'more-filters-' + idPrefix + inputName">
                        <span class="not-collapsed">
                            Minder {{ plural.toLowerCase() }}<i class="ml-3 fas fa-angle-up"></i>
                        </span>

                            <span class="is-collapsed">
                            Meer {{ plural.toLowerCase() }}<i class="ml-3 fas fa-angle-down"></i>
                        </span>
                        </a>
                    </div>
                </div>
            </div>



        </div>
    </div>
</template>

<script>
    import PageFilterMixin from './PageFilterMixin';

    export default {
        mixins: [PageFilterMixin],
        mounted() {
            // this.searchByFilters.increaseLoadedFilterCount();
        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/PageFilter.vue